/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCaretLeft = createReactComponent("caret-left", "IconCaretLeft", [
  ["path", { d: "M14 6l-6 6l6 6v-12", key: "svg-0" }]
]);

export { IconCaretLeft as default };
//# sourceMappingURL=IconCaretLeft.js.map
